import { createFileRoute } from '@tanstack/react-router';

import { chatbotReportScreen, loadChatbotMessages, loadChatbotReportScreen } from '@/modules/chatbot/route';
import { lazyScreen } from '@/shared/screen/lazy-screen';

// `/chatbot/relatorios` (router.tsx:757-763): só com `FEATURE_FLAGS.SHOW_REFUSAL_IN_CHATBOT`, que o manifesto confere.
export const Route = createFileRoute('/_app/chatbot/relatorios/')({
  staticData: { screen: chatbotReportScreen },
  loader: () => loadChatbotMessages(),
  component: lazyScreen(loadChatbotReportScreen, 'ChatbotReportRouteScreen'),
});
